<ion-header class="shadow-none ion-no-margin bg-transparent" [ngClass]="isMobileApp() ? 'ion-margin-bottom' : ''">
  <ion-toolbar>

    <!-- Page title -->
    <ion-text class="page-title ion-no-margin font-family-bold pb-0">
      {{ 'PRE_USE_LABEL1' | translate }}
    </ion-text>
  </ion-toolbar>

</ion-header>